/* global __CLIENT__*/
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from 'immutable';

import RelationshipTypeProperties from './RelationshipTypeProperties';
import Icon from '../../../components/Icon';
import InlineEditor from '../../../components/types/InlineEditor';
import String from '../../../components/types/String';
import TextArea from '../../../components/types/TextArea';

import { RelationshipTypeActions } from '../../../actions/relationshipType';
import { ModalActions } from '../../../actions/modal';

class RelationshipType extends Component {
  static propTypes = {
    relationshipType: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    icon: PropTypes.instanceOf(Map),
  };

  onSave = (value) => {
    const { relationshipType, dispatch } = this.props;
    const relationshipTypeId = relationshipType.get('id');

    dispatch(RelationshipTypeActions.renameRelationshipType(relationshipTypeId, value));
  }

  onSaveDescription = (value) => {
    const { relationshipType, dispatch } = this.props;
    const relationshipTypeId = relationshipType.get('id');
    dispatch(RelationshipTypeActions.saveDescription(relationshipTypeId, value));
  }

  toggleSelectIconModal = () => {
    const { dispatch, relationshipType } = this.props;

    dispatch(ModalActions.toggleModal({
      name: 'IconSelectModal',
      options: {
        componentType: 'relationshipTypes',
        componentId: relationshipType.get('id'),
      },
    }));
  }


  handleDelete = () => {
    const { relationshipType, dispatch } = this.props;
    const relationshipTypeId = relationshipType.get('id');
    const projectId = relationshipType.get('project_id');

    dispatch(RelationshipTypeActions.deleteRelationshipType({
      relationshipTypeId,
      projectId,
    }));
  }

  confirmDelete = () => {
    const { dispatch, relationshipType } = this.props;
    const name = relationshipType.get('type');

    dispatch(ModalActions.toggleModal({
      name: 'DeleteConfirmationModal',
      options: {
        deleteType: 'relationshipType',
        handleDelete: ::this.handleDelete,
        name,
      },
    }));
  }

  render() {
    const { relationshipType, icon } = this.props;
    if (!relationshipType) return <div />;

    const description = relationshipType.get('description');
    const uid = `relationshipType_${relationshipType.get('id')}`;
    const uidDescription = `relationship_type_description_${relationshipType.get('id')}`;
    const isLocked = relationshipType.getIn(['props', '_global', '_lock'], null);

    const title = (isLocked)
      ? relationshipType.get('type')
      : <InlineEditor
        style={{ display: 'inline' }}
        form={uid}
        component={String}
        value={relationshipType.get('type')}
        onSave={this.onSave}
      />;

    const deleteBtn = (isLocked)
    ? null
    : <button
      onClick={this.confirmDelete}
      type="button"
      className="btn btn-danger"
    >
      <i className="fa fa-trash"></i>
    </button>;

    return (
      <div className="inner-tab-container">
        <div className="tab-content">
          <section style={{ position: 'relative' }}>
            <div style={{ float: 'right' }}>
              {deleteBtn}
            </div>
            <h1 className="relationshipTypeName">
            <Icon
              icon={icon}
              toggleSelectIconModal={this.toggleSelectIconModal}
              pageType="relationshipType"
            />
            {title}
            </h1>
            <div style={{ marginBottom: 20 }}>
              <InlineEditor
                component={TextArea}
                style={{ display: 'inline' }}
                value={description}
                form={uidDescription}
                onSave={this.onSaveDescription}
              />
            </div>
          </section>
          <RelationshipTypeProperties
            relationshipType={relationshipType}
            currentRelationshipTypeId={relationshipType.get('id')}
          />
        </div>
      </div>
    );
  }
}

export default RelationshipType;



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/RelationshipType/RelationshipType.js